import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Text.css';

class Text extends React.Component {

  parent = null;
  inputRef = React.createRef();
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent != 'undefine' ? props.parent : null;
    this.ws_data = typeof props.ws_data != 'undefine' ? props.ws_data : null;

    this.state = {};
  }

  focus(){
    this.inputRef.focus();
  }

  render() {
    const {formData, formErrors} = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    let label = '';

    let input_type = 'text';
    if (ws_data.password) input_type = 'password';
    if (ws_data.email) input_type = 'email';
    if (ws_data.number) input_type = 'number';
    if (ws_data.type) input_type = ws_data.type;

    if (ws_data.fieldname === 'birthdate_txt') {
      input_type = 'date';
      label =  <label className="field_label" dangerouslySetInnerHTML={{__html: ws_data.label + (ws_data.required ? ' *' : '')}}></label> ;
    }

    if (parseInt(ws_data.react_display_label) === 1) {
      label =  <label className="field_label" dangerouslySetInnerHTML={{__html: ws_data.label + (ws_data.required ? ' *' : '')}}></label> ;
    }

    const conditionalProps = {};
    if (!!ws_data.text_maxlength) conditionalProps.maxLength = ws_data.text_maxlength;
    if (!!ws_data.text_minlength) conditionalProps.minLength = ws_data.text_minlength;
    
    if (ws_data.number && !!ws_data.text_max_value) conditionalProps.max = ws_data.text_max_value;

    return <div className="row">
      <div className={`field text ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>

        {label}

        <input 
          id={ws_data.fieldname}
          ref={(input)=>{this.inputRef=input;}}
          placeholder={`${ws_data.placeholder || ws_data.label} ${ws_data.required ? '*' : ''}`} 
          type={input_type} 
          readOnly={ws_data.readonly} 
          value={formData[ws_data.fieldname]} 
          onChange={(e) => parent.handle_change(e, ws_data.fieldname, {item: ws_data})}
          {...conditionalProps} 
        />
      
        {!!ws_data.html_after_input ? ws_data.html_after_input : ''}

        {!!ws_data.explanation ? <div className="form_explanation" dangerouslySetInnerHTML={{__html: ws_data.explanation}}></div> : ''}

        {(formErrors[ws_data.fieldname].length) 
          ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors[ws_data.fieldname]}}></div> : '' }
      </div>
    </div>;
  }
};

export default Text;
